import { render, staticRenderFns } from "./SearchItemsForm.vue?vue&type=template&id=3b7630a8&scoped=true"
import script from "./SearchItemsForm.vue?vue&type=script&lang=js"
export * from "./SearchItemsForm.vue?vue&type=script&lang=js"
import style0 from "./SearchItemsForm.vue?vue&type=style&index=0&id=3b7630a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7630a8",
  null
  
)

export default component.exports